








































import {Component, Prop, Vue} from "vue-property-decorator";
import PlayerHead from "@/components/PlayerHead.vue";
import Player from "@/components/Player.vue";
import {PlayerConfig} from "@/interfaces/player.interface";
import {IFilm} from "@/interfaces/film.interface";

@Component({
  components: {
    PlayerHead,
    Player
  }
})

export default class VideoContent extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  ignorePageMarginBreakpoint = PlayerConfig.IgnorePageMarginBreakpoints.MOBILE;

  activeItem: number = 0;

  @Prop() item: IFilm;
  @Prop() hideInfo: boolean;
  @Prop() customSubtitle: boolean;
  @Prop({ default: false }) hideActions?: boolean;
  @Prop({ default: false }) customType?: boolean;

  @Prop() isPlaylist: boolean;
  @Prop() list: any[];

  get getVideoInfo() {
    const item = (!this.isPlaylist) ? this.item : this.list[this.activeItem];
    return {
      title: item?.title,
      director: item?.director,
      year: item?.year,
      description: item?.info_text ? item?.info_text : item?.description,
      video_start: item?.video_start,
      loop_start: item?.loop_start,
      loop_end: item?.loop_end,
    }
  }

  get subtitle() {
    let result = '';
    const item = this.isPlaylist ? this.list[this.activeItem] : this.item;
    if (item.director && item.year) result = `${item.director}, ${item.year}`;
    if (this.customSubtitle) result = item.subtitle ? item.subtitle : '';
    return result;
  }

  onClick(payload: any) {
    this.activeItem = payload;
  }
}
